export default __webpack_public_path__ + "static/media/Automated Delivery and Consolidation case study.06c58d67.pdf";